export default __webpack_public_path__ + "static/media/logo.e409277a.svg";